import script from "./runningPage.vue?vue&type=script&setup=true&lang=js"
export * from "./runningPage.vue?vue&type=script&setup=true&lang=js"

import "./runningPage.vue?vue&type=style&index=0&id=2b95da58&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b95da58"]])

export default __exports__